/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpdateSettingRequest
 */
export interface RequestUpdateSettingRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateSettingRequest
     */
    baseId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestUpdateSettingRequest
     */
    isSeinoCorrection?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateSettingRequest
     */
    seinoCorrectionValue?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateSettingRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdateSettingRequest
     */
    updatedUserId?: number;
}

/**
 * Check if a given object implements the RequestUpdateSettingRequest interface.
 */
export function instanceOfRequestUpdateSettingRequest(value: object): value is RequestUpdateSettingRequest {
    return true;
}

export function RequestUpdateSettingRequestFromJSON(json: any): RequestUpdateSettingRequest {
    return RequestUpdateSettingRequestFromJSONTyped(json, false);
}

export function RequestUpdateSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdateSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'isSeinoCorrection': json['is_seino_correction'] == null ? undefined : json['is_seino_correction'],
        'seinoCorrectionValue': json['seino_correction_value'] == null ? undefined : json['seino_correction_value'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'updatedUserId': json['updated_user_id'] == null ? undefined : json['updated_user_id'],
    };
}

export function RequestUpdateSettingRequestToJSON(json: any): RequestUpdateSettingRequest {
    return RequestUpdateSettingRequestToJSONTyped(json, false);
}

export function RequestUpdateSettingRequestToJSONTyped(value?: RequestUpdateSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'is_seino_correction': value['isSeinoCorrection'],
        'seino_correction_value': value['seinoCorrectionValue'],
        'tenant_id': value['tenantId'],
        'updated_user_id': value['updatedUserId'],
    };
}

